import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiLoginRequest, ApiLoginResponse } from '@shared/models/interfaces/api-login.interface';
import { environment } from '@env';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthService {
    constructor(private router: Router, private http: HttpClient, private toastr: ToastrService) {}

    get isLoggedIn(): boolean {
        if (localStorage.getItem('jwt')) {
            return true;
        } else {
            return false;
        }
    }

    public login(body: ApiLoginRequest) {
        this.http
            .post<ApiLoginResponse>(`${environment.apiBaseUrl}/api/TokenAuth/Authenticate`, body)
            .pipe(map((res) => res.result))
            .subscribe(
                (res) => {
                    localStorage.setItem('jwt', res.accessToken);
                },
                (err) => {
                    const errormessage = 'Attenzione:<br />' + err.error?.error.message || 'si è verificato un errore';
                    this.toastr.error(errormessage, null, { timeOut: 1500, enableHtml: true });
                },
                () => {
                    this.router.navigateByUrl('prese-in-carico');
                }
            );
    }

    public logOut() {
        sessionStorage.clear();
        localStorage.clear();
        this.redirectToLogin();
    }

    redirectToLogin(): void {
        this.router.navigateByUrl(`/login`);
    }
}
